(() => {
  const configSource = document.getElementById('cz-pdp-shared-config');
  let config;
  try { config = JSON.parse(configSource?.textContent || '{}'); }
  catch (_) { return; }
  const productId = String(config?.productId || '');
  if (config?.master !== 'drapery' || !/^\d+$/.test(productId)) return;
  const reviewLayout = (['drapery', 'roman-shade', 'roller-shade'].includes(config?.controller)
    || config?.controller === 'handwoven-shade')
    && String(config?.kind || '').length > 0
    && String(config?.profile || '').length > 0
    && String(config?.handle || '').length > 0;
  let root, sourceCounts, observer, seenCounts = [0, 0], syncFrame = 0;
  const count = value => /^\d+$/.test(value || '') ? Number(value) : null;
  const tabCount = (tab, name) => {
    const match = tab?.textContent.trim().match(new RegExp('^' + name + '\\s*\\(([\\d,]+)\\)$'));
    return match ? Number(match[1].replaceAll(',', '')) : null;
  };
  function bindReviewJump(wrapper) {
    if (wrapper.dataset.czReviewJumpBound) return;
    wrapper.dataset.czReviewJumpBound = 'true';
    wrapper.addEventListener('click', event => {
      if (!event.target.closest('.jdgm-prev-badge__stars, .jdgm-prev-badge__text')) return;
      const target = document.querySelector('#judgeme_product_reviews[data-id="' + productId + '"]')
        || document.getElementById('judgeme_product_reviews');
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const jump = () => target.scrollIntoView({behavior, block: 'start'});
      if (innerWidth >= 768 && !document.documentElement.classList.contains('cz-header-detached')) {
        const detached = new MutationObserver(() => {
          if (!document.documentElement.classList.contains('cz-header-detached')) return;
          detached.disconnect();
          requestAnimationFrame(jump);
        });
        detached.observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
      }
      jump();
    }, true);
  }
  function arrangeLayout() {
    if (!reviewLayout) return;
    document.documentElement.classList.add('cz-pdp-review-layout');
    root?.setAttribute('data-cz-review-layout', '');
    const form = document.querySelector('.product-form[data-product-id="' + productId + '"]');
    const summary = form?.querySelector('.cz-drapery-product-summary');
    const badge = form?.querySelector('.jdgm-preview-badge');
    const preview = badge?.querySelector('.jdgm-prev-badge[data-number-of-reviews]');
    const wrapper = badge?.closest('.not-in-quickbuy-above-price') || badge?.parentElement;
    const reviews = count(preview?.getAttribute('data-number-of-reviews'));
    const hasReviews = reviews !== null && reviews > 0;
    summary?.classList.toggle('cz-drapery-product-summary--zero-reviews', !hasReviews);
    if (!wrapper) return;
    wrapper.classList.add('cz-pdp-review-badge');
    wrapper.hidden = !hasReviews;
    bindReviewJump(wrapper);
    if (summary && wrapper.parentElement !== summary) summary.append(wrapper);
  }
  function sync() {
    arrangeLayout();
    if (!root?.isConnected) return;
    const source = root.querySelector('.jdgm-rev-widg[data-number-of-reviews][data-number-of-questions]');
    if (source) sourceCounts = [count(source.getAttribute('data-number-of-reviews')), count(source.getAttribute('data-number-of-questions'))];
    const widget = root.querySelector('.jm-review-widget');
    const reviewsTab = widget?.querySelector('#jdgm-tab_product_reviews');
    const questionsTab = widget?.querySelector('#jdgm-tab_questions_answers');
    const displayed = [tabCount(reviewsTab, 'Reviews'), tabCount(questionsTab, 'Questions')];
    if (displayed.some(value => value === null)) {
      delete root.dataset.czReviewCount;
      delete root.dataset.czQuestionCount;
      return; // Judge.me has not finished loading.
    }
    // The initial product totals are retained so a later empty filter cannot hide real reviews.
    const totals = displayed.map((value, index) => Math.max(value, sourceCounts?.[index] ?? 0, seenCounts[index]));
    if (!sourceCounts && root.dataset.emptyState !== 'empty_widget' && totals[0] === 0) return;
    seenCounts = totals;
    root.dataset.czReviewCount = String(totals[0]);
    root.dataset.czQuestionCount = String(totals[1]);
    if (totals[0] === 0 && totals[1] > 0 && questionsTab.getAttribute('aria-selected') !== 'true') questionsTab.click();
    widget.querySelectorAll('option[value="product_reviews"]').forEach(option => { option.hidden = totals[0] === 0; option.disabled = totals[0] === 0; });
    widget.querySelectorAll('option[value="questions_answers"]').forEach(option => { option.hidden = totals[1] === 0; option.disabled = totals[1] === 0; });
  }
  function scheduleSync() {
    if (syncFrame) return;
    if (typeof requestAnimationFrame !== 'function') { sync(); return; }
    syncFrame = requestAnimationFrame(() => { syncFrame = 0; sync(); });
  }
  function bind(next) {
    if (next === root) return;
    observer?.disconnect();
    root = next;
    sourceCounts = null;
    seenCounts = [0, 0];
    if (!root) return;
    observer = new MutationObserver(scheduleSync);
    observer.observe(root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-number-of-questions']});
    sync();
  }
  const findRoot = () => document.querySelector('#judgeme_product_reviews[data-id="' + productId + '"]');
  bind(findRoot());
  arrangeLayout();
  new MutationObserver(() => { bind(findRoot()); scheduleSync(); }).observe(document.body, {childList: true, subtree: true});
})();
